// Translation: Ukrainian > Notifications
const notifications = Object.freeze({})

// Export
export default notifications
